import { defineComponent as f, openBlock as g, createBlock as C, unref as t, withModifiers as _, withCtx as k, renderSlot as x } from "vue";
import { _ as y } from "./AccessibleComponent.vue_vue_type_script_setup_true_lang-b6d6fe78.mjs";
import { useCollapseContext as b } from "@teamnovu/kit-composables";
const $ = /* @__PURE__ */ f({
  __name: "AccordionHeader",
  props: {
    is: { default: "summary" }
  },
  setup(u) {
    const c = u, e = b(), r = ["button", "summary"], n = () => {
      e && (e.toggle.value = !t(e.toggle));
    }, m = (o) => {
      r.includes(c.is) || o.key === "Enter" && n();
    };
    return (o, s) => {
      var a, i, l, d, p;
      return g(), C(y, {
        is: o.is,
        "omit-role-for": r,
        role: "button",
        "aria-expanded": (i = (a = t(e)) == null ? void 0 : a.toggle) == null ? void 0 : i.value,
        "aria-pressed": (d = (l = t(e)) == null ? void 0 : l.toggle) == null ? void 0 : d.value,
        "aria-controls": (p = t(e)) == null ? void 0 : p.id,
        tabindex: "0",
        onClick: [
          s[0] || (s[0] = _(() => {
          }, ["prevent"])),
          n
        ],
        onKeydown: m
      }, {
        default: k(() => [
          x(o.$slots, "default")
        ]),
        _: 3
      }, 8, ["is", "aria-expanded", "aria-pressed", "aria-controls"]);
    };
  }
});
export {
  $ as _
};
